export default class SelectRouteDto {
  routeId: number = 0;
}
